import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../lib/api-client';
import { ActionHistoryDetail } from '../../../common/action-history-grid/types/ActionHistoryDetail';

export const useGetROActionHistory = (retailOrderID: number, enabled: boolean) => {

    const { data, isLoading } = useQuery({
        queryKey: ['ro-action-history', retailOrderID],
        queryFn: async () => await apiClient.get('retail-order/action-history',
            { params: { retailOrderID: retailOrderID } }) as ActionHistoryDetail[],
        enabled: enabled
    });

    return {
        data: data || [],
        isLoading: isLoading
    };
};
